import type { DeliverableSetOption, FileValidationStatus } from '@/schema'

export type { DeliverableSetOption } from '@/schema'

export enum UploadPhase {
  INITIAL = 'initial',
  UNZIPPING = 'unzipping',
  VALIDATION = 'validation',
  UPLOAD = 'upload',
}

export enum VersionStatus {
  NEW_FILE = 'New File',
  NEW_VERSION = 'New Version',
}

export interface UploadFile {
  id: string
  file: File
  fileName: string
  fileSize: number
  fileType: string
  validationStatus: FileValidationStatus
  uploadProgress: number
  versionStatus?: VersionStatus
  errorMessage?: string
  uploadUrl?: string
  documentId?: string
  documentType?: string
  requiresManualType?: boolean
  hasAutoDetectedType?: boolean
  fileIndex?: number
  versionNumber?: number
  isInitial?: boolean
  blobName?: string
  blobUrl?: string
  isActionRequired?: boolean
  validationApiCalled?: boolean
}

export interface UploadState {
  files: UploadFile[]
  selectedDeliverableSet: DeliverableSetOption | null
  isUploading: boolean
  uploadProgress: number
  error: string | null
  showFloatingIndicator: boolean
  uploadPhase: UploadPhase
}

export interface FileUploadFilters {
  searchText: string
  status: FileValidationStatus | 'all'
}
